import {SEOManager} from "../../utilities/SEOManager";
import {Navbar} from "../../components/NavBar";
import Footer from "../../sections/Footer/Footer";
import React from "react";
import {Container} from "../../components/LayoutHelpers";

export default function Cookies() {
    return (
        <div id="inicio" className="page">
            <SEOManager/>
            <Navbar/>

            <main id="content">
                <section id="servicios" className="section-alt">
                    <Container>
                        <h2 className="h2">{"Política de Cookies"}</h2>
                        <p className="subtitle">{"Este sitio web únicamente utiliza cookies técnicas esenciales para su correcto funcionamiento."}</p>
                        <p className="subtitle">{"No se emplean cookies de análisis, publicidad ni de terceros que recojan datos de los usuarios con fines estadísticos o de marketing."}</p>
                        <p className="subtitle">{"El usuario puede configurar su navegador para bloquear o eliminar las cookies en cualquier momento, aunque ello puede afectar al funcionamiento del sitio."}</p>
                    </Container>
                </section>

            </main>

            <Footer/>
        </div>
    );
}